import React from 'react'; import ExtendedModulePage from './ExtendedModulePage'; export default function DomainsPage(){return <ExtendedModulePage moduleKey="domains"/>}
